<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
    />

    <table-organogram
      v-model="form.organogram"
      :readonly="board.readonly"
      :is-print="isPrint"
      title="조직도"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableOrganogram from "@/components/TableOrganogram.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    TableOrganogram,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        organogram: {},
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
